import currencyJS from "currency.js";
import i18n from "i18next";

export const currency = (value: string | number) => {
  return currencyJS(+value, {
    decimal: i18n.t("decimalSeparator"),
    separator: i18n.t("thousandSeparator"),
    symbol: i18n.t("currencySymbol"),
    pattern: i18n.t("currencyPattern"),
    negativePattern: i18n.t("negativeCurrencyPattern"),
  });
};
